import { createPureComponent } from 'module/Common';
import React from 'react';

type Props = {
  marginBottom?: number;
  marginTop?: number;
};

export const ArrowIcon = createPureComponent<Props>('ArrowIcon', ({ marginBottom = 0, marginTop = 0 }) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginBottom, marginTop }}
  >
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="A4" transform="translate(-271 -406)" fill="#000">
        <polygon
          id="Fill-1"
          points="279.8203 419.5868 278.8123 418.5358 283.7253 413.6648 271.0443 413.6648 271.0443 412.1528 283.7253 412.1528 278.8123 407.2818 279.8203 406.2328 286.5173 412.9088"
        />
      </g>
    </g>
  </svg>
));



// WEBPACK FOOTER //
// ./src/module/View/Menu/icons/ArrowIcon.tsx